// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaMessagePopup__container-b1d495 {
  display: flex;
  flex-direction: column;
  width: 440px;
  overflow: hidden;
  flex: 0 1 auto;
}

.MediaMessagePopup__send-as-file-checkbox-a924b8 {
  --checkbox-field-gap: 16px;
  margin: 8px 0 24px;
}

.MediaMessagePopup__content-a9bd8a {
  margin-top: 24px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: auto;
}

.MediaMessagePopup__footer-cc06b1 {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 16px 24px 16px;
}

.MediaMessagePopup__button-dd3895 {
  align-self: flex-end;
}

.MediaMessagePopup__input-container-fca8fd {
  margin-bottom: 20px;
}

.MediaMessagePopup__input-d00b20 {
  max-height: 150px;
}

.MediaMessagePopup__loader-ed2fb7 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/MediaMessagePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,0BAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 440px;\n  overflow: hidden;\n  flex: 0 1 auto;\n}\n\n.send-as-file-checkbox {\n  --checkbox-field-gap: 16px;\n\n  margin: 8px 0 24px;\n}\n\n.content {\n  margin-top: 24px;\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1;\n  overflow: auto;\n}\n\n.footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 16px;\n}\n\n.button {\n  align-self: flex-end;\n}\n\n.input-container {\n  margin-bottom: 20px;\n}\n\n.input {\n  max-height: 150px;\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60px;\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaMessagePopup__container-b1d495`,
	"send-as-file-checkbox": `MediaMessagePopup__send-as-file-checkbox-a924b8`,
	"sendAsFileCheckbox": `MediaMessagePopup__send-as-file-checkbox-a924b8`,
	"content": `MediaMessagePopup__content-a9bd8a`,
	"footer": `MediaMessagePopup__footer-cc06b1`,
	"button": `MediaMessagePopup__button-dd3895`,
	"input-container": `MediaMessagePopup__input-container-fca8fd`,
	"inputContainer": `MediaMessagePopup__input-container-fca8fd`,
	"input": `MediaMessagePopup__input-d00b20`,
	"loader": `MediaMessagePopup__loader-ed2fb7`
};
module.exports = ___CSS_LOADER_EXPORT___;
